import { CouldntHaveHappenedSlide } from './CouldntHaveHappenedSlide';
import { FundingSlide } from './FundingSlide';
import { IntroSlide } from './IntroSlide';
import { WorkMetricsSlide } from './WorkMetricsSlide';
import { ThankYouSlide } from './ThankYouSlide';

export const RecapSlides = [
  <IntroSlide key="intro-slide" />,
  <FundingSlide key="funding-slide" />,
  <CouldntHaveHappenedSlide key="couldnt-have-happened-slide" />,
  <WorkMetricsSlide key="work-metrics-slide" />,
  <ThankYouSlide key="thank-you-slide" />,
];
